import { inTocm, lbTokg } from '@/tools/unit-conversion'

const ct = {
  weight: 'grossWeight',
}

function toParamsString(key) {
  return ct[key] || key
}

export class TruckSetting {
  constructor(info) {
    this.weight = info.limitedWeight ? lbTokg(info.limitedWeight).toFixed(0) : null
    this.weightPerAxle = info.weightPerAxle ? lbTokg(info.weightPerAxle).toFixed(0) : null
    this.height = info.height ? inTocm(info.height).toFixed(0) : null
    this.width = info.width ? inTocm(info.width).toFixed(0) : null
    this.length = info.length ? inTocm(info.length).toFixed(0) : null
    this.axleCount = info.axleCount || null
    this.type = null
    this.trailerCount = info.trailersCount || null
    this.shippedHazardousGoods = info.shippedHazardousGoods ? info.shippedHazardousGoods.replace(/radioActive/g, 'radioactive') : null
  }

  toQueryParams() {
    const res = {}
    TruckSetting.KEYS.forEach(key => {
      if (this[key] !== null) {
        res[`truck[${toParamsString(key)}]`] = this[key]
      }
    })
    return res
  }
}

TruckSetting.TYPE = {
  STRAIGHT: 'straight',
  TRACTOR: 'tractor'
}

TruckSetting.KEYS = ['weight', 'weightPerAxle', 'height', 'width', 'length', 'axleCount', 'type', 'trailerCount', 'shippedHazardousGoods']
